export function range(n: number) {
  return (cb: (idx: number) => React.ReactNode) => Array.from({ length: n }, (_, idx) => cb(idx));
}
